import React from 'react';
// import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import CorrespondanceNewMessage from './correspondance_new_message/CorrespondanceNewMessage';
import CorrespondanceFeed from './correspondance_feed/CorrespondanceFeed';

const defaultCorType = {
  ['ANNOUNCEMENTS']: true,
  ['COMMENTS']: true,
  ['LOGS']: true,
  ['CALENDLY_UPDATE']: true,
  ['DIALPAD_SMS_TEXT']: true,
  ['DIALPAD_CALL_TRANSCRIPT']: true,
  ['EMAIL']: true,
};

const Correspondances = (props) => {
  const [corType, setCorType] = React.useState(defaultCorType);
  const [sortDir, setSortDir] = React.useState('DESC');
  const [messageMode, setMessageMode] = React.useState('INTERNAL_NOTES');
  const [messageRecipientRn, setMessageRecipientRn] = React.useState('');
  const [replyDraft, setReplyDraft] = React.useState(null);

  const onReplyToMessage = (draftData) => {
    setMessageMode('SEND_MESSAGE');
    setMessageRecipientRn(draftData.relationshipRn);
    setReplyDraft(draftData);
  };

  return (
    <Stack>
      <CorrespondanceNewMessage
        corType={corType}
        setCorType={setCorType}
        sortDir={sortDir}
        setSortDir={setSortDir}
        messageMode={messageMode}
        setMessageMode={setMessageMode}
        messageRecipientRn={messageRecipientRn}
        setMessageRecipientRn={setMessageRecipientRn}
        replyDraft={replyDraft}
        {...props}
      />
      <CorrespondanceFeed
        corType={corType}
        sortDir={sortDir}
        onReplyToMessage={onReplyToMessage}
        {...props}
      />
    </Stack>
  );
};
Correspondances.propTypes = {
};

export default React.memo(Correspondances);
